export default "__VITE_ASSET__VxR5lrTx__"